import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FundingOptions from './pages/FundingOptions';
import BusinessCreditBuilder from './pages/BusinessCreditBuilder';
import BusinessAcquisitions from './pages/BusinessAcquisitions';
import CommercialRELending from './pages/CommercialRELending';
import ApplyLanding from './pages/ApplyLanding';
import FundingBlueprint from './pages/FundingBlueprint';
import BlueprintFunnel from './pages/BlueprintFunnel';
import Testimonials from './pages/Testimonials';
import Resources from './pages/Resources';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Application from './pages/Application';
import Affiliate from './pages/Affiliate';
import Partners from './pages/Partners';
import Invest from './pages/Invest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import CookiePolicy from './pages/CookiePolicy';
import NotFound from './pages/NotFound';
import FundiChat from './components/FundiChat';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/funding-options" element={<FundingOptions />} />
        <Route path="/business-credit-builder" element={<BusinessCreditBuilder />} />
        <Route path="/business-acquisition" element={<BusinessAcquisitions />} />
        <Route path="/commercial-re-lending" element={<CommercialRELending />} />
        <Route path="/apply" element={<ApplyLanding />} />
        <Route path="/funding-blueprint" element={<FundingBlueprint />} />
        <Route path="/get-blueprint" element={<BlueprintFunnel />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/apply" element={<Application />} />
        <Route path="/affiliate" element={<Affiliate />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/invest" element={<Invest />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* <FundiChat /> */}
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
